module.exports = __webpack_public_path__ + "img/filter.94ef4b82.svg";